// todo: divide component
import React from 'react'
import { Trans } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useFeatureValue } from '@growthbook/growthbook-react'
import { FEATURE_KEYS } from '~/shared/constants/commonConstants'
import { PageId } from '~/shared/constants/pagesConstants'

import { Styles as S } from './styles'

type StepStatus = 'done' | 'active' | 'idle'

const STEPS = [
  {
    pageId: PageId.UPSELL_1,
    labelKey: 'upsell.postPaymentProgress.firstItem',
  },
  {
    pageId: PageId.LOGIN,
    labelKey: 'upsell.postPaymentProgress.secondItem',
  },
  {
    pageId: PageId.DOWNLOAD,
    labelKey: 'upsell.postPaymentProgress.thirdItem',
  },
]

const UPSELL_V3_STEPS = [
  STEPS[0],
  {
    pageId: PageId.LOGIN,
    labelKey: 'upsell.postPaymentProgress.welcomeOfferItem',
  },
  STEPS[2],
]

const PAGE_TO_STEP_INDEX: Record<string, number> = {
  [PageId.UPSELL_1]: 0,
  [PageId.LOGIN]: 1,
  [PageId.DOWNLOAD]: 2,
}

const getStepStatus = (stepIndex: number, currentIndex: number): StepStatus => {
  if (stepIndex < currentIndex) return 'done'
  if (stepIndex === currentIndex) return 'active'
  return 'idle'
}

const CheckIcon = () => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
    <path
      d="M1.5 6L5.5 10L14.5 1"
      stroke="white"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const UPSELL_V3_VARIANTS = new Set(['trial', 'toggle'])

const PostPaymentProgressBar = () => {
  const { pathname } = useLocation()
  const upsellV3Variant = useFeatureValue(
    FEATURE_KEYS.upsell_v3_anatomy_en,
    'control',
  )
  const upcellVariant = useFeatureValue(FEATURE_KEYS.upcell, 'control')
  const isUpcellVariant =
    upcellVariant === 'recurring-us' || upcellVariant === 'one-time-us'

  const currentPageId = pathname.replace(/^\//, '').split('/')[0]
  const isUpsellPage = currentPageId === PageId.UPSELL_1
  const showWelcomeOfferSteps =
    isUpsellPage && (UPSELL_V3_VARIANTS.has(upsellV3Variant) || isUpcellVariant)

  if (!(currentPageId in PAGE_TO_STEP_INDEX)) return null
  if (isUpsellPage && !showWelcomeOfferSteps) return null

  const steps = showWelcomeOfferSteps ? UPSELL_V3_STEPS : STEPS
  const statuses: StepStatus[] = showWelcomeOfferSteps
    ? ['done', 'done', 'idle']
    : STEPS.map((_, index) =>
        getStepStatus(index, PAGE_TO_STEP_INDEX[currentPageId]),
      )

  return (
    <S.Wrapper>
      {steps.map((step, index) => {
        const status = statuses[index]
        const isLast = index === steps.length - 1

        return (
          <React.Fragment key={step.pageId}>
            <S.StepItem>
              <S.StepLabel $active={status !== 'idle'}>
                <Trans i18nKey={step.labelKey} components={{ br: <br /> }} />
              </S.StepLabel>

              <S.StepCircle $status={status}>
                {status === 'done' ? <CheckIcon /> : index + 1}
              </S.StepCircle>
            </S.StepItem>
            {!isLast && <S.Connector $filled={status === 'done'} />}
          </React.Fragment>
        )
      })}
    </S.Wrapper>
  )
}

export default PostPaymentProgressBar
